import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { ImageUploadField } from "./ImageUploadField";

export function OfferForm({ formData, f, api }) {
  return (
    <>
      <div><Label className="text-sm">Titel</Label><Input value={formData.title || ""} onChange={e => f("title", e.target.value)} className="mt-1 bg-input/50 border-white/10 rounded-none" data-testid="dialog-title" /></div>
      <div><Label className="text-sm">Beschreibung</Label><Textarea value={formData.description || ""} onChange={e => f("description", e.target.value)} className="mt-1 bg-input/50 border-white/10 rounded-none" /></div>
      <div className="grid grid-cols-2 gap-3">
        <div><Label className="text-sm">Originalpreis</Label><Input type="number" step="0.1" value={formData.original_price || ""} onChange={e => f("original_price", parseFloat(e.target.value))} className="mt-1 bg-input/50 border-white/10 rounded-none" /></div>
        <div><Label className="text-sm">Angebotspreis</Label><Input type="number" step="0.1" value={formData.offer_price || ""} onChange={e => f("offer_price", parseFloat(e.target.value))} className="mt-1 bg-input/50 border-white/10 rounded-none" data-testid="dialog-offer-price" /></div>
      </div>
      <div><Label className="text-sm">Gültig bis</Label><Input type="date" value={formData.valid_until || ""} onChange={e => f("valid_until", e.target.value)} className="mt-1 bg-input/50 border-white/10 rounded-none" /></div>
      <ImageUploadField formData={formData} f={f} api={api} />
      <div className="flex items-center gap-2">
        <Switch checked={formData.active !== false} onCheckedChange={v => f("active", v)} />
        <Label className="text-sm">Aktiv</Label>
      </div>
    </>
  );
}
